import { createSlice } from '@reduxjs/toolkit'
import api from '../../Core/Services/Api'
import { ofType } from 'redux-observable'
import { from } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { manageMapEpicResponse } from '../../Common/Utils/Api'
import { apiMapSlice } from '../../Common/Utils/Redux'

const emptyData = []

// reducer
const messagesSlice = createSlice(apiMapSlice('messages'))

export const { request, success, failure } = messagesSlice.actions

export default messagesSlice.reducer

export const selectMessages = (state) => state.messages
export const selectMessagesData = (id) => (state) =>
  state.messages.data[id]?.value || emptyData
export const selectMessagesFetching = (id) => (state) => state.messages.fetching[id]
export const selectMessagesFetched = (id) => (state) => state.messages.fetched[id]

// side effects
export const fetchMessagesEpic = (action$) =>
  action$.pipe(
    ofType('messages/request'),
    mergeMap((action) => {
      return from(api.configurations.getAllMessages(action.payload)).pipe(
        ...manageMapEpicResponse(
          action.payload, // the map id
          success,
          failure,
          'configurator:errors.FetchMessagesError',
          true,
        ),
      )
    }),
  )
